export default {
  helpText: 'Please pick and sort the columns you want to see in the order over view table. This settings is applied globally for all users.',
  selectedColumns: 'Selected columns',
  nonSelectedColumns: 'Available columns',
};
